import React from "react";
import "../styles/loading.css";

function Loading() {
  return (
    <div className="loading">
      <div className="loader">Loading...</div>
    </div>
  );
}

export default Loading;
